import { Element, Footer as FooterBar } from 'common/components/FooterBar';
import Responsive from 'common/components/Responsive';
import Portal from 'projects/components/Portal';
import React from 'react';

export default class BriefFooter extends React.Component {
    render() {
        return (
            <Portal>
                <Responsive min="normal">
                    <FooterBar maxWidthVariation="widescreen">
                        <Element align="right">{this.props.children}</Element>
                    </FooterBar>
                </Responsive>
                <Responsive max="medium">
                    <FooterBar position={'relative'} maxWidthVariation="widescreen">
                        <Element align="right">{this.props.children}</Element>
                    </FooterBar>
                </Responsive>
            </Portal>
        );
    }
}
